import Input from '@creator/ui/components/Form/Input/Input';
import { toDateTimeLocal } from '@creator/ui/utils/date-utils';
import { memo, useMemo } from 'react';
import type { FC } from 'react';

interface SchedulePostInputProps {
    value?: string;
    onChange: (value: string) => void;
    isDisabled?: boolean;
    className?: string;
}

const SchedulePostInput: FC<SchedulePostInputProps> = props => {
    const { value = '', onChange, isDisabled = false, className = '' } = props;

    // Compute min (now) and max (one month ahead) once
    const minTime = useMemo(() => new Date(), []);
    const maxTime = useMemo(() => new Date(Date.now() + 1000 * 60 * 60 * 24 * 30), []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
    };

    return (
        <Input
            type="datetime-local"
            value={value}
            onChange={handleChange}
            isDisabled={isDisabled}
            className={className}
            min={toDateTimeLocal(minTime.toISOString())}
            max={toDateTimeLocal(maxTime.toISOString())}
        />
    );
};

export default memo(SchedulePostInput);
